/* lua.js generated code undefined */
let event = require('cocos/framework/components/event')
DATargetCounterV2 = xClass("DATargetCounterV2", event)
let _instance = null
DATargetCounterV2.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = DATargetCounterV2.create()
    }
    return _instance
}
DATargetCounterV2.prototype.ctor = function () {
    let self = this
    self.reset()
}
DATargetCounterV2.prototype.reset = function () {
    let self = this
    // 目标数记录列表
    self._targetCountList = table()
    self._currentTargetTotalCount = 0
    self._expectCountList = table()
    self._targetCountFormatStr = ""
    self._inLevel = false
    self._moveStep = 0
    self._orderItemDefs = table()
    self._orderItemCounted = table()
    self._showDropAdjustLoggerInGameScene = false
    self._propSteps = 0
    self._purchasePassTargetCount = 0
}
// 在关卡开始后调用
DATargetCounterV2.prototype.startLevel = function (levelId, recoverData, isFromReplay) {
    let self = this
    self.reset()
    self._inLevel = true
    if (recoverData && recoverData.replay && recoverData.replay.dropAdjustDataV2 && recoverData.replay.dropAdjustScheme) {
        self._targetCountList = table()
        self._expectCountList = clone(recoverData.replay.dropAdjustDataV2)
        self._purchasePassTargetCount  = recoverData.replay.dropAdjustScheme._purchasePassTargetCount
        console.log("替换DATargetCounterV2 _expectCountList", self._expectCountList)
        if (!isFromReplay) {
            self._propSteps = GameBoardLogic.instance.baseMoves - GameBoardLogic.instance.moveLimitFromConfig
            self._moveStep = $len(self._targetCountList)
            self._calCurrentTargetCount()
        }
    } else {
        self._targetCountList = table()
        if ((_G.DAUserDataV2 && _G.DAUserDataV2.getInstance().isOpen === true)) {
            self._expectCountList = DAManager.getInstance().getExpectCountListV2(levelId)
            self._purchasePassTargetCount = DAManager.getInstance().getItemStepExpectV2(levelId)
            console.log("【掉落优化】DATargetCounterV2 _expectCountList", self._expectCountList)
        }
        if (!isFromReplay) {
            self._propSteps = GameBoardLogic.instance.baseMoves - GameBoardLogic.instance.moveLimitFromConfig
            self._moveStep = $len(self._targetCountList)
            self._calCurrentTargetCount()
        }
    }
    self._prepareOrderList()
}
// 关前道具类型的加步数需要处理
DATargetCounterV2.prototype.addPrePropSteps = function (steps) {
    let self = this
    self._propSteps = self._propSteps + steps
    DAManagerGUILogger.getInstance().print("【掉落优化FUUU】关前道具步数 " + self._propSteps)
}
// 计算当前目标累积数
DATargetCounterV2.prototype._calCurrentTargetCount = function () {
    let self = this
    let count = 0
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        for (let _ in data) {
            let num = data[_]
            if ($null(num)) continue
            count = count + num
        }
    }
    self._currentTargetTotalCount = count
}
DATargetCounterV2.prototype.encode = function () {
    let self = this
    let data = {
        targetCountList: self._targetCountList,
        expectCountList: self._expectCountList
    }
    return data
}
// 在bonus time之前调用，表示关卡常规阶段结束（此时并不能知道是否过关，需等bonus time结束后判定过关再调用passLevel）
DATargetCounterV2.prototype.endLevel = function () {
    let self = this
    self._inLevel = false
}
// 在确定过关后调用
DATargetCounterV2.prototype.passLevel = function () {
    let self = this
    self._inLevel = false
    self.printTargetList()
    self._targetCountFormatStr = self._getFinalFormatStr()
}
// 在确定过关后调用
DATargetCounterV2.prototype.failLevel = function () {
    let self = this
    self.passLevel()
}
DATargetCounterV2.prototype._getFinalFormatStr = function (withBreak) {
    let self = this
    let str = ""
    let count = 0
    let dMoves = 0
    let realMoves = $len(self._targetCountList)
    let baseMoves = GameBoardLogic.instance.baseMoves
    DAManagerGUILogger.getInstance().print("关卡原始步数：" + baseMoves)
    DAManagerGUILogger.getInstance().print("实际使用步数：" + realMoves)
    if (realMoves > baseMoves) {
        dMoves = realMoves - baseMoves
        DAManagerGUILogger.getInstance().print("实际步数超过关卡步数\n需要去除" + dMoves + "步")
    } else if (realMoves < baseMoves) {
        let $limit25 = (baseMoves - realMoves)
        for (let i = 1; i <= $limit25; i += 1) {
            str = str + "0."
        }
    }
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        for (let _ in data) {
            let num = data[_]
            if ($null(num)) continue
            count = count + num
        }
        if (i >= 1 + dMoves) {
            // 只记录关卡配置的步数的范围，所以如果有加步数的情况需要去掉前面的步数
            if (i > 1 + dMoves) {
                str = str + "."
            }
            str = str + count
            if (withBreak && i % 10 === 0) {
                str = str + "\n"
            }
        }
    }
    return str
}
/*     @desc: 在需要计数的地方调用，以累加单步内的目标数
	--@addNum:  增加计数
    --@type:    障碍物type，例如itemType或lockType
    --@color:   <可选参数> 障碍的颜色
    --@r:       <可选参数> 障碍所在行
    --@c:       <可选参数> 障碍所在列
    --@isDynamicProduct: <可选参数> 是否动态生成的，202206掉落干预新加参数
    --@lockColor: <可选参数> lockType的颜色，202206掉落干预新加参数
 */
DATargetCounterV2.prototype.tryAddTargetCount = function (addNum, type, color, r, c, isDynamicProduct, lockColor) {
    let self = this
    if (!self._inLevel || addNum <= 0) {
        return 
    }
    // isDynamicProduct, lockColor：202206掉落干预新加参数，老的掉落干预不需要
    // 动态生成的收集目标判断是否需要计数
    // print("tryAddTargetCount type="..tostring(type).." color="..tostring(color).." lockColor="..tostring(lockColor))
    // print("tryAddTargetCount addNum="..addNum)
    if (!isDynamicProduct) {
        // print("tryAddTargetCount 非动态生成")
        // DAManagerGUILogger:getInstance():print("tryAddTargetCount type="..tostring(type).." 非动态生成")
    } else {
        let tempType = type
        if (type === GameItemType.kGum) {
            tempType = color + GameItemDefMapKey.kGum_0
        } else if (type === LockItemType.kColoredFrosting) {
            tempType = (lockColor - 1) * 2 + 1 + GameItemDefMapKey.kColoredFrosting_0_2
        }
        // print("tryAddTargetCount 动态生成 tempType="..tostring(tempType))
        if (type === GameItemType.kStarfish || type === GameItemType.kPaw || GameBoardLogic.instance.isCollectingItem(tempType) || GameBoardLogic.instance.isCollectingColorItem(color, null, tempType)) {
            // print("tryAddTargetCount type="..tostring(type).." 动态生成且正在收集")
            DAManagerGUILogger.getInstance().print("tryAddTargetCount type=" + tostring(type) + " 动态生成且正在收集")
        } else {
            // print("tryAddTargetCount type="..tostring(type).." 动态生成且收集完成不计数")
            DAManagerGUILogger.getInstance().print("tryAddTargetCount type=" + tostring(type) + " 动态生成且收集完成不计数")
            return 
        }
    }
    let countItemDefs = table()
    let itemDef = self._getItemDefInOrderList(type, color)
    if (type === -1001) {
        // boss
        itemDef = table([1, "id", "boss"])
    }
    // 部分覆盖物盖住收集物，在减层时也要统计
    if (!itemDef && (type === GameItemType.kVar_Snow || type === LockItemType.kWoodBox || type === GameItemType.kDiamond || type === GameItemType.kShell || type === GameItemType.kLock || type === GameItemType.kIce || type === LockItemType.kFilbert)) {
        if (r && c && GameBoardLogic.instance) {
            // 冰层覆盖水果
            if (type === GameItemType.kIce) {
                let seaAnimalType = GameBoardLogic.instance.getSeaAnimalTypeAtRC(r, c)
                if (seaAnimalType === 65) {
                    seaAnimalType = 64
                }
                if (seaAnimalType === 67) {
                    seaAnimalType = 68
                }
                if (seaAnimalType) {
                    itemDef = self._getItemDefInOrderList(seaAnimalType, null)
                }
            } else {
                let coverItem = GameBoardLogic.instance.getGameItemAt(r, c)
                let coverType = coverItem.itemType
                if (coverType === 0) {
                    coverType = coverItem.lockType
                }
                let forceColor = null
                if (coverType >= GameItemDefMapKey.kSurpriseBox_1 && coverType <= GameItemDefMapKey.kSurpriseBox_2) {
                    // 巧克力盒子
                    coverType = GameItemDefMapKey.kSurpriseBonus
                } else if (coverType === GameItemDefMapKey.kHoneyBottle) { // 蜂蜜罐
                    coverType = GameItemDefMapKey.kHoney
                } else if (coverType === GameItemDefMapKey.kAlienA) { // 完整的橙子
                    coverType = GameItemDefMapKey.kAlienB
                    forceColor = 21
                }
                // 查看是否覆盖了收集物
                if (self._getItemDefInOrderList(coverType, forceColor || coverItem.color || coverItem.itemColorType)) {
                    itemDef = GameItemDefManager.getDef(type)
                }
                // 如果底下有蜂蜜块，并且目标收集物包含蜂蜜块，那么计数
                let boardItem = GameBoardLogic.instance.getGameBoardAt(r, c)
                if (boardItem.honeyLevel > 0) {
                    let def = self._getItemDefInOrderList(GameItemDefMapKey.kHoney, null)
                    table.insert(countItemDefs, def)
                }
            }
        }
    }
    // ai打关计数统计会需要统计一些线上未统计的item
    if (!itemDef) {
        let itemDef = table()
        if (type === GameItemType.kChain || type === GameItemType.kHoneyBottle || type === GameItemType.kSuperHoneyBottle || type === GameItemType.kCoin || type === GameItemType.kStarfish || type === GameItemType.kFlowerVine || type === GameItemType.kFurball || type === GameItemType.kBowknot || type === GameItemType.kHoney || type === GameItemType.kShell || type === GameItemType.kDiamond || type === GameItemType.kRatel || type === GameItemType.kIceBomb || type === GameItemType.kJam || type === GameItemType.kLamp || type === GameItemType.kEgg || type === GameItemType.kSoil || type === GameItemType.kReef || type === GameItemType.kVar_Snow || type === GameItemType.kLock || type === GameItemType.kCake || type === GameItemType.kSurpriseBox || type === GameItemType.kSurpriseBonus || type === GameItemType.kCheeseRat || type === GameItemType.kPastry || type === LockItemType.kMint || type === LockItemType.kMushroom || type === LockItemType.kSeaAnemone || type === LockItemType.kFilbert || type === LockItemType.kGummyWorm || type === LockItemType.kCandyFloss || type === LockItemType.kVulnerable || type === LockItemType.kColoredFrosting || type === LockItemType.kCroissant || type === LockItemType.kBiscuit || type === CeilItemType.kDinnertable || type === CoverItemType.kNestDoll || type === LockItemType.kNest || type === LockItemType.kHunter || type === LockItemType.kCannedFish || type === GameItemType.kJamBox || type === GameItemType.kFoamBomb || type === GameItemType.kIcePopBox || type === LockItemType.kSafe || type === LockItemType.kSupportStick || type === GameItemType.kCircusB || type === GameItemType.kCircusBall || type === GameItemType.kWoodBox || type === CeilItemType.kCandyCane || type === GameItemDefMapKey.kMangosteen_0) {
            itemDef.id = type
        }
        if (itemDef.id) {
            table.insert(countItemDefs, itemDef)
        }
    }
    if (itemDef) {
        table.insert(countItemDefs, itemDef)
    }
    for (let _ = 1, itemDef = countItemDefs[1]; itemDef; _++, itemDef = countItemDefs[_]) {
        if (itemDef && self._moveStep >= 0) {
            let key = tostring(itemDef.id)
            let moveStep = self._moveStep
            if (moveStep === 0) {
                moveStep = 1
                if ($len(self._targetCountList) === 0) {
                    table.insert(self._targetCountList, moveStep, table())
                }
            }
            let data = self._targetCountList[moveStep]
            if (!data[key]) {
                data[key] = 0
            }
            data[key] = data[key] + addNum
            self._currentTargetTotalCount = self._currentTargetTotalCount + addNum
            self._orderItemCounted[tostring(key)] = true
            DATargetCountGUILogger.getInstance().updateLoggerInGameScene()
        }
    }
}
// 在玩家操作一步并棋盘稳定时调用
DATargetCounterV2.prototype.oneStepMoved = function () {
    let self = this
    if (!self._inLevel) {
        return 
    }
    self._moveStep = self._moveStep + 1
    if (self._moveStep > $len(self._targetCountList)) {
        table.insert(self._targetCountList, self._moveStep, table())
    }
    DATargetCountGUILogger.getInstance().updateLoggerInGameScene()
    self.printTargetList()
}
// 获取当前步数的累积计数
DATargetCounterV2.prototype.getCurrentTargetCount = function () {
    let self = this
    let count = 0
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        for (let _ in data) {
            let num = data[_]
            if ($null(num)) continue
            count = count + num
        }
    }
    return count
}
// 获取当前步数的期望计数
DATargetCounterV2.prototype.getCurrentExpectCount = function () {
    let self = this
    let count = 0
    if (self._moveStep > 0) {
        let moveStep = self._moveStep - self._propSteps
        moveStep = Math.min(moveStep, $len(self._expectCountList))
        count = self._expectCountList[moveStep] || 0
    }
    return count
}
// 获取线上付费过关完成度
DATargetCounterV2.prototype.getPurchasePassTargetCount = function () {
    let self = this
    return self._purchasePassTargetCount
}
/*     @desc: 最近一次的计数统计格式化string
 */
DATargetCounterV2.prototype.getTargetCountFormatStr = function () {
    let self = this
    return self._targetCountFormatStr
}
DATargetCounterV2.prototype.printTargetList = function () {
    let self = this
    cc.log("--------------- DATargetCounter List ---------------")
    for (let i = 1, data = self._targetCountList[1]; data; i++, data = self._targetCountList[i]) {
        let str = "Step " + i + "\t\t"
        for (let itemType in data) {
            let count = data[itemType]
            if ($null(count)) continue
            str = str + itemType + ": " + count + "\t"
        }
        //print(str)
    }
    cc.log("--------------- DATargetCounter List ---------------")
}
DATargetCounterV2.prototype._prepareOrderList = function () {
    let self = this
    let orderList = GameBoardLogic.instance.theOrderList
    if (orderList) {
        let itemDefs = GameItemDefManager.defs
        for (let k in orderList) {
            let v = orderList[k]
            if ($null(v)) continue
            let itemDef = itemDefs[tostring(v.def_id)]
            if (itemDef) {
                let itemId = tostring(itemDef.id)
                self._orderItemDefs[itemId] = itemDef
                self._orderItemCounted[itemId] = false
            }
        }
    }
}
DATargetCounterV2.prototype._getItemDefInOrderList = function (type, color) {
    let self = this
    if (type === null || type == undefined) {
        return false
    }
    for (let defId in self._orderItemDefs) {
        let itemDef = self._orderItemDefs[defId]
        if ($null(itemDef)) continue
        if (type === itemDef.itemType || type === itemDef.lockType || type === itemDef.coverType || type === itemDef.id) {
            if (color !== null && itemDef.color !== null && (color !== itemDef.color && itemDef.color !== 0)) {
                if (itemDef.color === 0 || color === itemDef.color) {
                    return itemDef
                } else {
                    // Do nothing.
                }
            } else {
                return itemDef
            }
        }
    }
    return null
}
DATargetCounterV2.prototype._doOrder = function (type, color) {
    let self = this
    let itemDef = self._getItemDefInOrderList(type, color)
    let exclude = (itemDef && itemDef.id === 158)
    if (itemDef && !exclude && self._orderItemCounted[tostring(itemDef.id)] === false) {
        if (__WIN32 && !GameBoardLogic.instance.replaying) {
            cc.log("障碍物" + itemDef.id + "被收集，但并未调用DATargetCounter计数，详见掉落优化文档", 30)
            cc.log("请在tryDoOrderAnimal或tryDoOrderByItemDefMapKey之前调用tryDoOrderAnimal")
        }
    }
}
DATargetCounterV2.prototype.isV2Enable = function () {
    let self = this
    // 202207 当前收集数据两套计数规则共存
    return true
}
